import React from "react";
import EditContactInfoLine from "./EditContactInfoLine";
import NewContactInfoLine from "./NewContactInfoLine";
import InlinePendingRow from "../InlinePendingRow";

// The contact-details table — one editable row per contact info plus the "new record" affordance.
// Shared by every entity that owns id_contact_infos (media outlets, media profiles, ...). Unlike
// the company edit forms (one form per singleton social field) this is a collection editor:
// id_contact_infos allows an owner several rows of the same type, so rows are keyed and mutated by
// the row id, never by type.
function ContactInfoEditorActive({
  contactInfoState: { contactInfos, addContactInfo, removeContactInfo, updateContactInfo, isUpdating },
}) {
  return (
    // Fixed layout with an explicit percentage per column, and table-responsive so a narrow viewport
    // scrolls rather than crushing the action column. (Same treatment as the publications editor.)
    <div className="table-responsive">
      <table className="table" style={{ tableLayout: "fixed", minWidth: "32rem" }}>
        <colgroup>
          <col style={{ width: "24%" }} />
          <col style={{ width: "60%" }} />
          <col style={{ width: "16%" }} />
        </colgroup>
        <thead>
          <tr>
            <th>Type</th>
            <th>Value</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {contactInfos.map((line) => (
            <EditContactInfoLine
              key={line.id}
              contactInfo={line}
              onChange={(updatedFields) => updateContactInfo(line.id, updatedFields)}
              onRemove={() => removeContactInfo(line.id)}
              disabled={isUpdating}
            />
          ))}
          <NewContactInfoLine onNewContactInfo={addContactInfo} disabled={isUpdating} />
          <InlinePendingRow isPending={isUpdating} />
        </tbody>
      </table>
    </div>
  );
}

export default ContactInfoEditorActive;
